import { useState, useCallback } from 'react';
import { parseValidationErrors } from '@/utils/validationErrors';

const useFormValidation = () => {
  const [fieldErrors, setFieldErrors] = useState({});
  const [generalErrors, setGeneralErrors] = useState([]);

  const setBackendErrors = useCallback((errorResponse) => {
    const {
      fieldErrors: newFieldErrors,
      generalErrors: newGeneralErrors,
    } = parseValidationErrors(errorResponse);

    setFieldErrors(newFieldErrors);
    setGeneralErrors(newGeneralErrors);
  }, []);

  const clearFieldError = useCallback((fieldName) => {
    setFieldErrors((prev) => {
      if (!prev[fieldName]) {
        return prev;
      }

      const updated = { ...prev };
      delete updated[fieldName];
      return updated;
    });
  }, []);

  const clearAllErrors = useCallback(() => {
    setFieldErrors({});
    setGeneralErrors([]);
  }, []);

  const setClientFieldErrors = useCallback((errors) => {
    setFieldErrors((prev) => ({ ...prev, ...errors }));
  }, []);

  const clearGeneralErrors = useCallback(() => {
    setGeneralErrors([]);
  }, []);

  const hasErrors = useCallback(() => {
    return Object.keys(fieldErrors).length > 0 || generalErrors.length > 0;
  }, [fieldErrors, generalErrors]);

  const hasFieldError = useCallback(
    (fieldName) => {
      return !!fieldErrors[fieldName];
    },
    [fieldErrors],
  );

  return {
    fieldErrors,
    generalErrors,
    setBackendErrors,
    setClientFieldErrors,
    clearFieldError,
    clearAllErrors,
    clearGeneralErrors,
    hasErrors,
    hasFieldError,
  };
};

export default useFormValidation;
